
/**
 * _this为传过来的this
 * 
 * 根据参数str,去获取到对应的下拉框的值
 * 
 * paramName,接收的数组，如'type'
 * 
 * 先去redis总查询，如果没有值，再去数据库中查询
 */
import api from '@/api/api_domain'


export function GetSelect(_this,str,paramName) {
	
    let para = {
		key: str
	};
	
	if(typeof str === "undefined" || str == ""){
	//	return options;
	}else{
		//console.log(_this)
		_this.$api.domain.domainGetDomainKeyRedis(para).then((res) => {
																									
			_this[paramName] = res.data.data.listDomainDefine;
		//	console.log("...",_this[paramName]);
												
		}).catch((err)=>{
	　　　　console.log(err);
	　　});
	}

}





// WEBPACK FOOTER //
// ./src/api/getSelect.js